angular.module('picmonicng').directive('yearSelect', [
  function () {
    return {
      restrict: 'E',
      scope: {
        yearId: '=',
        isRequired: '=',
      },
      link: function (scope, element, attrs) {
        scope.years = [];
        var start_year = new Date().getFullYear();
        for (var a = 0; a < 10; a++) {
          scope.years.push(start_year + a);
        }

        if (!isNaN(scope.isRequired) && scope.isRequired > 0) {
          scope.isRequired = true;
        } else if (scope.isRequired == '') {
          scope.isRequired = false;
        }
      },
      templateUrl: '/templates/directives/year-select.html',
    };
  },
]);
